import { useQuery } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { termsList } from '../types';

export const getFaqList = async (): Promise<termsList[]> => {
  const response = await axios.get(`/api/v1/user/faq`, {
})
  //return response?.data;
   const data = response.data;
  return data;
};

type QueryFnType = typeof getFaqList;

type UseFaqListOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useRulesList = ({  config }: UseFaqListOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['data'],
    queryFn: () => getFaqList(),
    ...config,
  });
};